<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card class="pa-4">
      <div class="d-flex align-center mb-6">
        <div class="text-h6">
          {{
            approve
              ? "Aprovar solicitação de cancelamento"
              : "Recusar solicitação de cancelamento"
          }}
        </div>

        <v-spacer />

        <v-btn color="primary" :disabled="loading" small icon @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <section class="mb-8">
        <div class="text-body-1">
          {{
            approve
              ? "Deseja aprovar esta solicitação de cancelamento de assinatura?"
              : "Deseja recusar esta solicitação de cancelamento de assinatura?"
          }}
        </div>
      </section>

      <div class="d-flex justify-end">
        <v-btn
          v-if="!loading"
          class="text-none rounded-lg mr-2"
          :loading="loading"
          text
          @click="close()"
        >
          Cancelar
        </v-btn>

        <v-btn
          class="text-none rounded-lg"
          color="primary"
          :loading="loading"
          depressed
          @click="submit()"
        >
          Confirmar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { request } from "@/services";

export default {
  name: "ManageNiche",

  data() {
    return {
      loading: false,
      dialog: false,
      approve: false,
      unsubscriptionID: "",
    };
  },

  computed: {
    _rules() {
      return [(v) => !!v || "Campo Obrigatório"];
    },

    _isCreator() {
      const type = this.$route.query.type;

      return !type || type === "creators";
    },
  },

  methods: {
    async submit() {
      if (!this.approve && !this.$refs.form.validate()) return;

      try {
        this.loading = true;

        const payload = {
          method: this._isCreator ? "setCancelado" : "setCanceladoBrands",
          cancelamentoID: this.unsubscriptionID,
        };

        await request(payload);

        this.handleAlert(
          this.approve
            ? "Solicitação aprovada com sucesso"
            : "Solicitação recusada com sucesso",
          "success"
        );

        this.$emit("update");
        this.close();
      } catch (error) {
        this.handleAlert(error.data.message, "error");
      } finally {
        this.loading = false;
      }
    },

    handleAlert(title, type) {
      this.$root.$emit("alert", { title, type });
    },

    open(data, value) {
      this.unsubscriptionID = data.id;
      this.approve = value;

      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
